import './styles.scss';
import { Close } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useCallback, useContext, useState } from 'react';

import { PortfolioManagementContext } from '../../../providers/portfolio-management';

import { PortfolioSidebarSettingsGeneral } from './portfolio-sidebar-settings-content/portfolio-sidebar-settings-general';
import { PortfolioSidebarSettingsRisk } from './portfolio-sidebar-settings-content/portfolio-sidebar-settings-risk';
import { PortfolioSidebarSettingsOption } from './portfolio-sidebar-settings-option';

export const PortfolioSidebarSettings = () => {
  const { setIsPortfolioSidebarSettingsOpen } = useContext(PortfolioManagementContext);
  const [selectedOption, setSelectedOption] = useState('risk');

  const handlePortfolioSidebarClose = useCallback(() => {
    setIsPortfolioSidebarSettingsOpen(false);
  }, []);

  const handleClickOption = (option: string) => () => {
    setSelectedOption(option);
  };

  return (
    <div className="portfolio-sidebar-settings-container">
      <div className="portfolio-sidebar-settings-nav">
        <div className="portfolio-sidebar-settings-button-close">
          <Button onClick={handlePortfolioSidebarClose}>{<Close />}</Button>
        </div>
        <div className="portfolio-sidebar-settings-content">
          <div className="portfolio-sidebar-settings-content-options">
            <PortfolioSidebarSettingsOption
              label="Risk"
              handleClick={handleClickOption('risk')}
              isActive={selectedOption === 'risk'}
            />
            <PortfolioSidebarSettingsOption
              label="General"
              handleClick={handleClickOption('general')}
              isActive={selectedOption === 'general'}
            />
          </div>
          <div className="portfolio-sidebar-settings-content-view">
            {selectedOption === 'risk' && <PortfolioSidebarSettingsRisk />}
            {selectedOption === 'general' && <PortfolioSidebarSettingsGeneral />}
          </div>
        </div>
      </div>
    </div>
  );
};
